module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"title":"Contacto","follow-us":"Síguenos en Twitter"},"en":{"title":"Contact Us","follow-us":"Follow us on Twitter"}}')
  delete Component.options._Ctor
}
